import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'inicio',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // Drivers
        {
          path: '/conductores/getDrivers',
          name: 'getDrivers',
          meta: {
            title: 'Conductores',
          },
          component: () => import('./views/drivers/getDrivers'),
        },
        // Driver
        {
          path: '/conductores/getDriver/:id',
          name: 'getDriver',
          meta: {
            title: 'Conductor',
          },
          component: () => import('./views/drivers/getDriver'),
        },
        // Rent
        {
          path: '/renta/payRent',
          name: 'payRent',
          meta: {
            title: 'Renta',
          },
          component: () => import('./views/rent/payRent'),
        },
        {
          path: '/renta/listPaymentsRent',
          name: 'listPaymentsRent',
          meta: {
            title: 'Renta',
          },
          component: () => import('./views/rent/listPaymentsRent'),
        },
        {
          path: '/renta/cardinal',
          name: 'cardinal',
          meta: {
            title: 'Renta',
          },
          component: () => import('./views/rent/cardinal'),
        },
        // Concessions
        {
          path: '/concesiones/getConcessions',
          name: 'getConcessions',
          meta: {
            title: 'Concesiones',
          },
          component: () => import('./views/concessions/getConcessions'),
        },
        // start
        {
          path: '/inicio',
          name: 'inicio',
          meta: {
            title: 'inicio',
          },
          component: () => import('./views/start/startRoute'),
        },
        {
          path: '/metodosdepago',
          name: 'Metodos de pago',
          meta: {
            title: 'Metodos de pago',
          },
          component: () => import('./views/paymentMethods/savedPaymentMethods'),
        },
        {
          name: 'map',
          path: '/mapa',
          meta: {
            title: 'Mapa',
          },
          component: () => import('./views/map/index.vue'),
        },
        {
          name: 'changePassword',
          path: '/cambiarContraseña',
          meta: {
            title: 'Cambio de contraseña',
          },
          component: () => import('./views/profile/changePassword/index.vue'),
        },
        {
          path: '/trips/getTrips',
          name: 'getTrips',
          meta: {
            title: 'Trips',
          },
          component: () => import('./views/trips/getTrips'),
        },
      ],
    },
    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.authorized) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
